export const STRUCTURE_EDITOR_BREAKPOINT = 1240;
export const BREAKPOINT_RESOLUTION = 1024;
export const TABLET_RESOLUTION = 1024;
export const MOBILE_RESOLUTION = 768;
